import { Calendar, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { openGoogleCalendar, downloadICS } from "@/lib/calendar";

export default function AddToCalendar({ booking, variant = "default", size = "default" }) {
  if (!booking || !booking.id) {
    return null;
  }

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <Button
        variant={variant}
        size={size}
        onClick={() => openGoogleCalendar(booking)}
        className="flex items-center gap-2"
      >
        <Calendar className="h-4 w-4" />
        Ajouter à mon agenda Google
      </Button>
      
      <Button
        variant={variant === "default" ? "outline" : variant}
        size={size}
        onClick={() => downloadICS(booking.id)}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Télécharger l&apos;événement (.ics)
      </Button>
    </div>
  );
}
